export default["__VITE_ASSET__BV6ckvNr__","__VITE_ASSET__DpoRgNUf__"];